var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 73,
    viewBox: "0 0 58 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9164 56.0798V56.0309L57.8966 51.4491L57.5938 50.93L49.9164 55.3387V32.4787L40.0406 26.9038V16.5892L49.0121 21.675L49.6099 20.6331L29.1848 9.05823V0H28.5794V9.05823L8.15418 20.6331L8.75202 21.675L28.5794 10.4388V20.4826L7.85147 32.7834V43.6247L0.302706 39.2385L0 39.7577L7.85525 44.3206V56.5274L27.9437 67.9518L20.0506 72.4809L20.3533 73L38.8941 62.3543L47.2526 67.2107L47.5553 66.6916L39.4957 62.0082L49.8294 56.076H49.9126L49.9164 56.0798ZM39.2763 16.1566H38.8336V26.223L29.1886 20.776V10.4388L39.2763 16.1566ZM29.1886 22.1566L38.8336 27.6035V50.0347L29.1886 55.2334V22.1566ZM9.06608 33.4718L28.5869 21.8857V55.6735L19.3165 50.2867V29.6386H18.1095V49.587L9.06608 44.3319V33.4718ZM9.06608 45.0241L18.1095 50.2792V60.9738L9.06608 55.8315V45.0241ZM28.7194 67.5079L28.935 67.1355L19.3127 61.6622V50.9826L38.2925 62.012L28.7156 67.5116L28.7194 67.5079ZM29.7032 56.3243L40.0406 50.7494V28.2844L48.7094 33.1784V56.0309L38.8979 61.6659L29.7032 56.3243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.97b3bd3f717f57b2149e07452369c544.svg";
export { ForwardRef as ReactComponent };